// Import registered React components

import {AccessDenied} from '/src/com/yext/platform/users/js/accessdenied';
import {AccessDeniedHelpLinks} from '/src/com/yext/platform/users/js/accessdeniedhelplinks';
import {InvalidSetPasswordLink} from '/src/com/yext/platform/users/js/invalidsetpasswordlink';
import {NewForgotPassword} from '/src/com/yext/platform/users/js/newforgotpassword';
import {NewForgotPasswordConfirm} from '/src/com/yext/platform/users/js/newforgotpasswordconfirm';
import {NewPartitionLogin} from '/src/com/yext/platform/users/js/newpartitionlogin';
import {NoProductAccess} from '/src/com/yext/platform/users/js/noproductaccess';
import {ResetPassword} from '/src/com/yext/platform/users/js/resetpassword';
import {ResetPasswordConfirm} from '/src/com/yext/platform/users/js/resetpasswordconfirm';

const initElements = document.getElementsByClassName('js-yext-login-init');

if (initElements.length > 0) {
  const initData = JSON.parse(initElements[0].innerHTML);
  window['cspStyleNonce'] = initData['cspStyleNonce'];
}
